import React, { memo } from 'react'

import { H2 } from '@frame/ui-primitives/h2'

type Props = {
  isVisible: boolean
}

export const DragOverlay = memo(function DragOverlay({ isVisible }: Props) {
  if (!isVisible) return null

  return (
    <div className="absolute left-0 top-[74px] z-50 h-[calc(100%-74px)] w-full bg-white bg-opacity-80 px-4 py-5 backdrop-blur-sm">
      <div className="relative left-0 top-0 flex h-full w-full items-center justify-center rounded-xl border-[4px] border-dashed">
        <H2>Drop file(s) here</H2>
      </div>
    </div>
  )
})
